import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API_CONFIG } from "config/config.jsx";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import InputLabel from "@material-ui/core/InputLabel";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  Card,
  Button,
  CardFooter,
  CardBody,
  FormGroup,
  Input,
  Container,
  Col,
  Form,
  FormFeedback,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { logout } from "../../../actions/auth";

class ChangePassword extends Component {
  state = {
    confirmPassword: "",
    password: "",
    confirmPasswordState: "",
    passwordState: "",
    loading: false,
    otp: this.props.otp,
    email:this.props.email,
    // countryCode: ''
  };
  // componentWillReceiveProps(props) {
  //   if (!props.resStatus && props.resMessage) {
  //     this.setState({ loading: false })
  //     let options = {
  //       place: "tc",
  //       message: '  ' + props.resMessage,
  //       type: "warning",
  //       icon: "fas fa-exclamation-triangle",
  //       autoDismiss: 4
  //     };
  //     if (this.refs.notificationAlert.state.notifyTC.length < 1) {
  //       this.refs.notificationAlert.notificationAlert(options);
  //     }
  //   }
  // }
  verifyLength = (value, length) => {
    if (value.length >= length) {
      return true;
    }
    return false;
  };
  change = (event, stateName, type) => {
    switch (type) {
      case "password":
        if (this.verifyLength(event.target.value, 5)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "confirmPassword":
        if (
          this.verifyLength(event.target.value, 5) &&
          this.state.password === event.target.value
        ) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      default:
        break;
    }
    this.setState({ [stateName]: event.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    if (
      this.state.confirmPasswordState === "has-success" &&
      this.state.passwordState === "has-success"
    ) {
      this.setState({ loading: true });
      // let email =  sessionStorage.getItem('plugoUserMobileNo');
      let token = sessionStorage.getItem("plugoAuthKey");
      try {
        await axios
          .post(
            `${API_CONFIG.HOST}/user/reset-password`,
            {
              otp: this.state.otp,
              email: this.state.email,
              password: this.state.password,
            },
            !(this.state.email) && {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((res) => {
            this.setState({ loading: false });
            
            if(this.state.email){
              this.props.handleForgotPassword()
            }
            else{
              this.props.logout();
            }
            console.log({ res });
          });
      } catch (err) {
        console.log({ err });
      }
    } else if (
      this.state.confirmPasswordState === "" &&
      this.state.passwordState === ""
    ) {
      this.setState({ confirmPasswordState: "has-danger" });
      this.setState({ passwordState: "has-danger" });
    } else if (this.state.confirmPasswordState === "") {
      this.setState({ confirmPasswordState: "has-danger" });
    } else if (this.state.passwordState === "") {
      this.setState({ passwordState: "has-danger" });
    }
  };

  render() {
    let { confirmPasswordState, passwordState } = this.state;
    return (
      <div>
        <Box
          mb={3}
          sx={{
            //   display: "flex",

            width: "100%",
            px: 3,
            //   justifyContent: "center",
          }}
        >
          <Form className="form" onSubmit={this.handleSubmit}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                rowGap: 3,
                mb: 2,
              }}
            >
              <FormGroup className={`has-label ${passwordState}`}>
                <label>Password *</label>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText style={{ border: "1px solid #E9ECEF" }}>
                      <i className="fas fa-lock" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="off"
                    placeholder="enter new password"
                    valid={passwordState === "has-success"}
                    invalid={passwordState === "has-danger"}
                    onChange={(e) => this.change(e, "password", "password")}
                    style={{ border: "1px solid " }}
                  />
                </InputGroup>
                <FormFeedback
                  valid={passwordState === "has-success"}
                  invalid={passwordState === "has-danger"}
                >
                  {this.state.passwordState === "has-danger" ? (
                    "Password is required."
                  ) : (
                    <span />
                  )}
                </FormFeedback>
              </FormGroup>
              <FormGroup className={`has-label ${confirmPasswordState}`}>
                <label>Confirm Password *</label>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText style={{ border: "1px solid #E9ECEF" }}>
                      <i className="fas fa-lock" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    id="confirmPassword"
                    name="confirmPassword"
                    type="password"
                    autoComplete="off"
                    valid={confirmPasswordState === "has-success"}
                    invalid={confirmPasswordState === "has-danger"}
                    placeholder="confirm password"
                    onChange={(e) =>
                      this.change(e, "confirmPassword", "confirmPassword")
                    }
                    style={{ border: "1px solid " }}
                    autoCapitalize="off"
                  />
                </InputGroup>
                <FormFeedback
                  valid={confirmPasswordState === "has-success"}
                  invalid={confirmPasswordState === "has-danger"}
                >
                  {this.state.confirmPasswordState === "has-danger" ? (
                    "confirm password is required."
                  ) : (
                    <span />
                  )}
                </FormFeedback>
              </FormGroup>

              {/* <FormGroup>
                     
                    </FormGroup> */}
            </Box>
          </Form>
          <Button
            fullwidth
            type="submit"
            block
            color="success"
            size="sm"
            onClick={this.handleSubmit}
            disabled={
              !(
                confirmPasswordState === "has-success" &&
                passwordState === "has-success"
              )
            }
          >
            Change Password
          </Button>
        </Box>
      </div>
    );
  }
}

export default connect(
  null,
  { logout }
)(ChangePassword);
